<template>
  <div id="organization">
    <a-card hoverable :bordered="false" style="margin-bottom: 16px">
      <a-row>
        <span>发布时间：</span>
        <a-date-picker
          @change="onStart"
          format="YYYY-MM-DD"
          placeholder="请选择开始日期"
          v-model="start"
        />
        -
        <a-date-picker
          v-model="end"
          @change="onEnd"
          placeholder="请选择结束日期"
          style="margin-right: 10px"
        />
        <span>创建日期：</span>
        <a-date-picker
          @change="onStart1"
          format="YYYY-MM-DD"
          placeholder="请选择开始日期"
          v-model="start1"
        />
        -
        <a-date-picker
          v-model="end1"
          @change="onEnd1"
          placeholder="请选择结束日期"
        />
        <a-input
          style="margin: auto 10px; width: 200px"
          ref="userNameInput"
          v-model="title_like"
          allowClear
          placeholder="输入通知标题搜索"
          ><a-icon slot="prefix" type="search" />
        </a-input>
        <a-button
          style="margin-left: 10px"
          type="primary"
          @click="getData(status)"
        >
          搜索
        </a-button>
        <a-button style="margin-left: 10px" @click="resetVal"> 重置 </a-button>
      </a-row>
    </a-card>
    <a-card hoverable :bordered="false">
      <a-tabs :default-active-key="status" @change="tabChange">
        <a-tab-pane
          :key="2"
          :tab="'待发布(' + status_count.wait_count + ')'"
          force-render
        ></a-tab-pane>
        <a-tab-pane
          :key="1"
          :tab="'已发布(' + status_count.pub_count + ')'"
        ></a-tab-pane>
        <a-button
          v-if="status != 1"
          slot="tabBarExtraContent"
          type="primary"
          @click="showModal('发布')"
        >
          新增通知
        </a-button>
      </a-tabs>
      <a-table
        :columns="columns"
        :data-source="data"
        :scroll="{ y: tableH - 80 }"
        :pagination="pagination"
      >
        <span slot="id" slot-scope="text, record, index">
          {{ pagination.pageSize * (pagination.current - 1) + index + 1 }}
        </span>
        <span slot="status" slot-scope="text, record, index">
          <span v-if="record.status" style="color: #1abc9c"> 已发布 </span>
          <span v-else> 待发布 </span>
        </span>
        <span slot="receive" slot-scope="text, record">
          <a-popover title="通知对象" v-if="record.receive">
            <template slot="content">
              <p v-for="item in record.receive" style="margin: 5px 0">
                <span>{{ item }}</span>
              </p>
            </template>
            <a type="primary"> 查看 </a>
          </a-popover>
        </span>
        <span slot="handle" slot-scope="text, record">
          <a v-if="!record.status" @click="issueNotice(record)">发布</a>
          <a-divider v-if="!record.status" type="vertical" />
          <a v-if="record.status" @click="showExamine(record)">查看</a>
          <a
            style="color: chocolate"
            v-if="!record.status"
            @click="showModal('编辑', record)"
            >编辑</a
          >
          <a-divider v-if="!record.status" type="vertical" />
          <a class="red" v-if="!record.status" @click="delectNot(record)"
            >删除</a
          >
        </span>
      </a-table>
    </a-card>
    <a-modal
      :title="modal_title + '通知'"
      :visible="modal"
      :confirm-loading="confirmLoading"
      :destroyOnClose="true"
      :maskClosable="false"
      @cancel="modal = false"
      width="950px"
    >
      <a-form
        ref="collectionForm"
        :form="form"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 21 }"
      >
        <a-form-item label="标题">
          <a-input
            allowClear
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入通知标题!' }],
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="通知类型">
          <a-select
            allowClear
            v-decorator="[
              'notice_type_id',
              {
                rules: [{ required: true, message: '请选择通知类型!' }],
              },
            ]"
          >
            <a-select-option
              v-for="item in notice_type_list"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item> -->
        <a-form-item label="通知对象">
          <a-select
            mode="multiple"
            allowClear
            placeholder="请选择报审机构,选填"
            @change="publishChange"
            @select="publishSelect"
            v-decorator="[
              'publish_ids',
              {
                rules: [
                  {
                    required: auditorArr.length ? false : true,
                    message: '请选择通知对象！',
                  },
                ],
              },
            ]"
          >
          <a-select-option value="all">全选</a-select-option>
            <a-select-option v-for="item in publish_list" :value="item.id">{{
              item.publish_name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-row>
          <a-col :span="3"></a-col>
          <a-col :span="20">
            <a-form-item>
              <!-- <span slot="label" style="display:none">
              通知对象
            </span> -->
              <a-select
                style="width: 120%"
                mode="multiple"
                allowClear
                placeholder="请选择审核机构,选填"
                @change="auditorChange"
                @select="auditorSelect"
                v-decorator="[
                  'auditor_ids',
                  {
                    rules: [
                      {
                        required: publishArr.length ? false : true,
                        message: '请选择通知对象！',
                      },
                    ],
                  },
                ]"
              >
              <a-select-option value="all">全选</a-select-option>
                <a-select-option
                  v-for="item in auditor_list"
                  :value="item.id"
                  >{{ item.check_publish_name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="通知内容">
          <richText
                v-decorator="[
                  'content',
                  {
                  rules: [{ required: true, message: '请填写通知内容!' }],
                  },
              ]"
              :text="contents"
              @editorChange="editorChange"
              @reset="reset"
            />
        </a-form-item>
        <a-form-item label="上传附件">
          <div>
            <a-upload
              :style="{
                'margin-top': isFileList && !fileList.length ? '28px' : '',
              }"
              :remove="removes"
              multiple
              @preview="previewModal"
              :beforeUpload="beforeUpload"
              :customRequest="customUpload"
              name="logo"
              list-type="picture"
            >
              <a-button> <a-icon type="upload" />选择文件</a-button
              ><!-- <span class="red"
                ><br />{{
                  isFileList.length
                    ? ""
                    : "*只能上传word/pdf/jpg/png格式文件，文件不能超过2m"
                }}</span
              > -->
            </a-upload>
          </div>
          <div style="line-height: 24px" v-if="fileArr.length">
            <p>已上传文件：</p>
            <div class="flex" style="flex-wrap: wrap">
              <p
                class="flex"
                style="margin: auto 10px"
                v-for="(item, index) in fileArr"
              >
                <a :href="item.url"
                  ><span>{{ item.name }}</span></a
                ><a-icon
                  style="margin: auto 0; margin-left: 5px"
                  @click="delectFile(item, index)"
                  type="close"
                />
              </p>
            </div>
          </div>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button
          type="primary"
          :loading="confirmLoading"
          @click="handleOk(modal_title, '2')"
        >
          保存并发布
        </a-button>
        <a-button
          type="primary"
          :loading="confirmLoading"
          @click="handleOk(modal_title, '1')"
        >
          保存
        </a-button>
        <a-button :loading="confirmLoading" @click="modal = false">
          取消
        </a-button>
      </template>
    </a-modal>
    <a-modal
      title="通知内容"
      :visible="examine_modal"
      :destroyOnClose="true"
      @cancel="examine_modal = false"
      width="800px"
    >
      <h2
        style="
          border-bottom: 1px solid #ccc;
          text-align: center;
          font-weight: bold;
          padding-bottom:10px
        "
      >
        {{ editVal.title }}
      </h2>
      <div class="ql-editor" v-html="editVal.content" style="margin-bottom: 10px"></div>
      <div v-if="editVal.files && editVal.files.length" style="border-top:1px solid #ccc;padding-top:10px">
        <span style="font-weight:bold">附件：</span><a
          :href="item.url"
          style="margin: 0 10px"
          v-for="item in editVal.files"
          >{{ item.name }}</a
        >
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: "编号",
    dataIndex: "id",
    key: "id",
    align: "center",
    scopedSlots: { customRender: "id" },
  },
  {
    title: "标题",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  // {
  //   title: "通知类型",
  //   dataIndex: "notice_type",
  //   key: "notice_type",
  //   align: "center",
  // },
  {
    title: "通知对象",
    dataIndex: "receive",
    key: "receive",
    scopedSlots: { customRender: "receive" },
    align: "center",
  },
  {
    title: "创建日期",
    key: "create_date",
    dataIndex: "create_date",
    align: "center",
    sorter: (a, b) => {
      return a.upload_time > b.upload_time ? 1 : -1;
    },
  },
  // {
  //   title: "发布日期",
  //   key: "publish_date",
  //   dataIndex: "publish_date",
  //   align: "center",
  //   sorter: (a, b) => {
  //     return a.upload_time > b.upload_time ? 1 : -1;
  //   },
  // },
  // {
  //   title: "状态",
  //   key: "status",
  //   dataIndex: "status",
  //   align: "center",
  //   scopedSlots: { customRender: "status" },
  // },
  {
    title: "操作",
    key: "handle",
    dataIndex: "handle",
    align: "center",
    scopedSlots: { customRender: "handle" },
  },
];

const data = [];

import {
  notice_list,
  upload_notice_files,
  add_new_notice,
  edit_notice,
  publish_notice,
  look_notice,
  del_notice,
} from "@/api/notice";
import { limitFileSize } from "@/utils.js";
import { type_dictionary } from "@/api/dictionary";
import { publish_list } from "@/api/association";
import { org_list } from "@/api/organization";
import richText from '@/components/editor'
// import E from "wangeditor-antd";
export default {
  data() {
    return {
      data,
      columns,
      check_publish_name: "",
      confirmLoading: false,
      modal: false,
      examine_modal: false,
      tableH: "",
      modal_title: "发布",
      modal_btn: "创建",
      editKey: 0,
      loading: false,
      form: this.$form.createForm(this, { name: "coordinated" }),
      pagination: {
        //表格分页
        current: 1,
        total: 0,
        pageSize: 20, //每页中显示10条数据
        showSizeChanger: true,
        showLessItems: true,
        // hideOnSinglePage: true,
        pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
        onChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
        onShowSizeChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
      },
      start: "",
      end: "",
      start1: "",
      end1: "",
      title_like: "",
      fileList: [],
      isFileList: [],
      status: 2, //列表状态
      status_count: null, //列表数量状态
      uploadList: [], //上传队列数组
      onQueue: false, //是否在上传
      uploadItems: [], //正在上传的数组
      uploadLen: 5, //上传文件个数限制
      uploadLine: 0, //上传文件线程

      publish_list: [], //报审机构列表
      auditor_list: [], //审核机构列表

      publish_ids: [], //报审机构id集
      auditor_ids: [], //审核机构id集
      notice_type_list: [], //通知类型列表

      publishArr: [], //判断报审机构选择
      auditorArr: [], //判断审核机构选择
      isAuditor: false, //判断报审机构
      fileArr: [], //数据回显列表
      edit_id: null, //修改需要的id参数

      editVal: "", //修改需要的参数
      contents:"",//富文本组件需要的参数
    };
  },
  components: { richText },
  created() {
    this.getData(this.status);
  },
  mounted() {
    //表格高度自适应
    this.$nextTick(function () {
      this.tableH = document.body.clientHeight - 250; //259
      // tableDom.style.height= this.tableH+"px" //表格滚动条预留
    });
    //窗口改变自适应
    window.onresize = () => {
      return (() => {
        this.tableH = window.innerHeight - 250; //259
        // tableDom.style.height= this.tableH+"px" //表格滚动条预留
      })();
    };
  },
  methods: {
    //验证文本
    reset() {
      this.form.setFieldsValue({content:null})
      console.log("重置没有")
    },
    //接收组件传值
      editorChange(html) {
        // console.log(html)
        this.form.setFieldsValue({content:html})
      	this.contents = html
    	},
    //发布通知
    issueNotice(record) {
      let that = this;
      this.$confirm({
        title: "发布提示",
        content: `确定要发布本条通知吗？`,
        onOk() {
          return new Promise((resolve, reject) => {
            // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            publish_notice({ notice_id: record.id })
              .then((res) => {
                if (res) {
                  that.$message.success(res.message);
                  that.getData();
                  resolve();
                }
              })
              .catch((err) => {
                reject();
              });
          });
        },
        onCancel() {
          that.$destroyAll();
        },
      });
    },

    //删除待发布列表的通知
    delectNot(record) {
      let that = this;
      this.$confirm({
        title: "删除提示",
        content: `确定要删除这条通知吗？`,
        onOk() {
          return new Promise((resolve, reject) => {
            // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
            del_notice({ notice_id: record.id })
              .then((res) => {
                if (res) {
                  that.$message.success(res.message);
                  that.getData();
                  resolve();
                } else {
                  reject();
                }
              })
              .catch((err) => {
                reject();
              });
          });
        },
        onCancel() {
          that.$destroyAll();
        },
      });
    },

    //删除编辑列表的文件
    delectFile(item, index) {
      console.log(item);
      let that = this;
      this.$confirm({
        title: "删除提示",
        content: `确定要删除${item.name}这个附件吗？`,
        onOk() {
          return new Promise((resolve, reject) => {
            that.fileArr.splice(index, 1);
            resolve();
          });
        },
        onCancel() {
          that.$destroyAll();
        },
      });
    },

    //获取通知列表
    getType() {
      type_dictionary("type=公告类型").then((res) => {
        if (res) {
          this.notice_type_list = res.data;
        }
      });
    },
    //获取报审机构所有列表
    getOrg() {
      org_list({ page_size: 1000, page_no: 1 })
        .then((res) => {
          if (res) {
            this.publish_list = res.data;
            this.publish_ids = []
            this.publish_list.map(item=>{
              this.publish_ids.push(item.id)
            })
          }
        })
        .catch((err) => {});
    },
    //获取审核机构列表
    getPublish() {
      publish_list({ page_no: 1, page_size: 999 })
        .then((res) => {
          if (res) {
            this.auditor_list = res.data;
            this.auditor_ids = []
            this.auditor_list.map(item=>{
              this.auditor_ids.push(item.id)
            })
            
          }
        })
        .catch((err) => {});
    },
    //判断报审机构
    publishRules(rule, value, cb) {
      if (value) {
        cb();
      } else {
        cb("请选择通知对象！");
      }
    },
    //判断审核机构
    auditorRules(rule, value, cb) {
      if (value) {
        cb();
      } else {
        cb("请选择通知对象！");
      }
    },
    //选择报审机构
    publishChange(val) {
      console.log(val);
      const str = val.join(",")
      // if(str.indexOf("all") != -1){
      //   console.log("全选")
      //   this.publishArr = this.publish_ids
      //   console.log(this.publishArr)
      // }else{
        this.publishArr = val;
      // }
    },
    publishSelect(val){
      console.log(val)
      if(val == 'all'){
        // this.publishChange(this.publish_ids)
        this.form.setFieldsValue({
          publish_ids: this.publish_ids,
        });
      }
    },
    //选择审核机构
    auditorChange(val) {
      console.log(val);
      const str = val.join(",")
      // if(str.indexOf("all") != -1){
      //   console.log("全选")
      //   this.auditorArr = this.auditor_ids
      //   console.log(this.auditorArr)
      // }else{
        this.auditorArr = val;
      // }
    },
    auditorSelect(val){
      if(val == 'all'){
        // this.publishChange(this.publish_ids)
        this.form.setFieldsValue({
          auditor_ids: this.auditor_ids,
        });
      }
    },
    //重置搜索框
    resetVal() {
      this.start = "";
      this.start1 = "";
      this.end = "";
      this.end1 = "";
      this.title_like = "";
    },

    //时间选择器
    onStart(data, dateString) {
      console.log(dateString);
      this.start = dateString;
    },
    onEnd(data, dateString) {
      console.log(dateString);
      let y = parseInt(dateString.split("-")[0]);
      let yy = parseInt(this.start.split("-")[0]);
      let m = parseInt(dateString.split("-")[1]);
      let mm = parseInt(this.start.split("-")[1]);
      let d = parseInt(dateString.split("-")[2]);
      let dd = parseInt(this.start.split("-")[2]);
      if (y < yy) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else if (m < mm) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else if (d < dd) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else {
        this.end = dateString;
      }
    },

    //时间选择器
    onStart1(data, dateString) {
      console.log(dateString);
      this.start1 = dateString;
    },
    onEnd1(data, dateString) {
      console.log(dateString);
      let y = parseInt(dateString.split("-")[0]);
      let yy = parseInt(this.start1.split("-")[0]);
      let m = parseInt(dateString.split("-")[1]);
      let mm = parseInt(this.start1.split("-")[1]);
      let d = parseInt(dateString.split("-")[2]);
      let dd = parseInt(this.start1.split("-")[2]);
      if (y < yy) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end1 = "";
      } else if (m < mm) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end1 = "";
      } else if (d < dd) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end1 = "";
      } else {
        this.end1 = dateString;
      }
    },

    //获取机构信息
    getData() {
      this.$store.commit("spinning", true);
      let data = `page_no=${this.pagination.current}&page_size=${this.pagination.pageSize}&pub_status=${this.status}&create_date_start=${this.start1}&create_date_end=${this.create_date_end}&pub_date_start=${this.start}&pub_date_end=${this.end}&title_like=${this.title_like}`;
      notice_list(data).then((res) => {
        console.log("获取审核机构列表", res);
        if (res) {
          this.pagination.total = res.data.total;
          this.data = res.data.list;
          this.status_count = res.data.status_count;
          this.$store.commit("spinning", false);
        }
      });
    },
    //弹窗
    showModal(val, record) {
      this.modal = true;
      this.modal_title = val;
      this.getType();
      this.getOrg();
      this.getPublish();
      this.fileArr = [];
      if (val == "编辑") {
        this.contents = ""
        look_notice(`notice_id=${record.id}`).then((res) => {
          if (res) {
            let data = res.data;
            this.form.setFieldsValue({
              title: data.title,
              notice_type_id: data.notice_type.id,
              publish_ids: data.publish,
              auditor_ids: data.auditor,
              // content: data.content,
            });
            this.contents = data.content;
            this.publishArr = data.publish;
            this.auditorArr = data.auditor;
            this.fileArr = data.files;
            this.edit_id = data.id;
          }
        });
      } else {
        this.edit_id = null;
        this.publishArr = [];
        this.auditorArr = [];
      }
    },
    //查看通知弹窗
    showExamine(record) {
      this.examine_modal = true;
      this.editVal = "";
      look_notice(`notice_id=${record.id}`).then((res) => {
        if (res) {
          console.log(res);
          this.editVal = res.data;
          this.editVal.content.replace(/\\n/, "<br/>");
          console.log(this.editVal);
        }
      });
    },
    //保存并发布||保存
    handleOk(title, type) {
      const form = this.$refs.collectionForm.form;
      form
        .validateFields((err, values) => {
          if (err) {
            return;
          }
          let flag = false 
          this.fileList.map((item,index)=>{
            if(item == 'error'){
              flag = true
              return
            }
          })
          if(flag){this.$message.error("列表存在错误文件，请删除后重试")
            return
          }
          console.log(values);
          // debugger
          values.save_type = type;
          values.notice_type_id = "0"
          values.publish_ids
            ? (values.publish_ids = values.publish_ids.join(","))
            : "";
          values.auditor_ids
            ? (values.auditor_ids = values.auditor_ids.join(","))
            : "";
          console.log(values);
          this.confirmLoading = true;
          if (this.edit_id) {
            values.notice_id = this.edit_id;
            let arr = [];
            this.fileArr.map((item) => {
              arr.push(item.url);
            });
            
            values.files = [...this.fileList, ...arr];
            console.log(values.files);
            edit_notice(values).then((res) => {
              if (res) {
                console.log(res.data);
                this.$message.success(res.message);
                this.confirmLoading = false;
                this.form.resetFields();
                this.modal = false;
                this.getData();
              } else {
                this.confirmLoading = false;
              }
            });
          } else {
            values.files = this.fileList;
            add_new_notice(values).then((res) => {
              if (res) {
                console.log(res.data);
                this.$message.success(res.message);
                this.confirmLoading = false;
                this.form.resetFields();
                this.modal = false;
                this.getData();
              } else {
                this.confirmLoading = false;
              }
            });
          }
        })
        .catch((err) => {
          this.confirmLoading = false;
        });
    },
    //销毁弹窗
    destroyAll() {
      this.$destroyAll();
    },
    /* 自定义提交按钮方法组——预览 */
    previewModal(file) {
      console.log(file);
      if (file.type.split("/")[0] != "image") {
        window.open(file.path);
      } else {
        this.previewImage = file.url;
        this.previewVisible = true;
      }
    },
    beforeUpload(file) {
      console.log("beforeUpload", file);
      const size = limitFileSize(file, "10MB");
      const typeStr = "word/pdf/jpg/png";
      const type =
        file.name.indexOf("docx") != -1 ||
        file.name.indexOf("pdf") != -1 ||
        file.name.indexOf("jpg") != -1 ||
        file.name.indexOf("png") != -1;
      let rep = true;
      // this.fileList.map((item) => {
      //   if (item.name == file.name) {
      //     return (rep = false);
      //   }
      // });
      return new Promise((resolve, reject) => {
        /* if (!type) {
          this.$message.error({
            content: file.name + "文件格式错误，上传失败",
            duration: 3,
          });
          reject();
        } else  */if (!size) {
          this.$message.error({
            content: file.name + "文件超过10M，上传失败",
            duration: 3,
          });
          reject();
        } else if (!rep) {
          this.$message.error({
            content: file.name + "文件已存在",
            duration: 3,
          });
        } else {
          let URL = window.URL || window.webkitURL;
          file.url = require("@/assets/word.png");
          file.path = URL.createObjectURL(file);
          resolve();
        }
      });
    },
    removes(fileList) {
      console.log(fileList);
      console.log(this.fileList);
      console.log(this.fileArr);
      if(fileList.response.err){
        this.fileList.map((item, index) => {
        if (fileList.response.err  == item) {
          this.fileList.splice(index, 1);
          console.log(this.fileList);
          return;
        }
      });
      }else{
        this.fileList.map((item, index) => {
        if(fileList.response.data[0] == item){
          this.fileList.splice(index, 1);
          console.log(this.fileList);
          return;
        }
      });
      }
    },
    //转换默认格式
    normFile(e) {
      // console.log("Upload event:", e);
      console.log(e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    //将文件push进uploadList中,此时uploadList变化,触发watch中的监听方法,开始第一次队列上传
    customUpload(data) {
      this.uploadList.push(data);
    },
    //上传限制
    uploadLimit(items) {
      //遍历文件长度，就循环几次上传队列函数
      for (let item of items) {
        this.queueUpload(item);
      }
    },
    //队列上传
    queueUpload(data) {
      this.onQueue = true;
      //开始上传该文件后，对应的上传文件线程+1
      this.uploadLine++;
      console.log("this.uploadLine", this.uploadLine);
      console.log("this.uploadLine.data", data);
      // this.customRequest(file)
      const _this = this;
      let params = new FormData();
      // params.append("file", data.file);
      params.append("files[]", data.file);
      // params.append("id", this.workId);

      // 发送请求
      upload_notice_files(params).then((res) => {
        if (res) {
          data.onSuccess(res, data.file); //解决一直loading情况，调用onSuccess
          // 赋值给数组在table中显示上传列表
          // 在上传成功后进度条显示为99
          setTimeout(() => {
            progress.percent = 100;
          }, 1000);
          _this.$message.success(`上传成功`); //上传成功显示
          this.spliceUpload(data.file);
          this.fileList.push(res.data[0]);
        } else {
          data.onError("上传错误", data.file); //解决一直loading情况，调用onSuccess
          data.file.err = "error";
          console.log("上传失败后的文件", data);
          // _this.$message.error(`上传失败`); //上传成功显示
          this.fileList.push('error');
          this.spliceUpload(data.file);
        }
      });

      let progress = { percent: 60 };
      const intervalId = setInterval(() => {
        // 控制进度条防止在未上传成功时进度条达到100
        if (
          progress.percent < 99 ||
          progress.percent + 100 / (data.file.size / 65000 < 100)
        ) {
          progress.percent += 100 / (data.file.size / 65000); //控制进度条速度
          data.onProgress(progress); //onProgress接收一个对象{ percent: 进度 }在进度条上显示
        } else if ((progress.percent = 99)) {
          progress.percent++;
        } else if ((progress.percent = 100)) {
          clearInterval(intervalId);
        }
      }, 100);
    },

    //上传成功后的操作,无论此文件添加成功或失败，uploaList都进行删除此文件
    spliceUpload(file) {
      this.onQueue = false;
      let index = this.uploadList.findIndex((item) => {
        return item.file.name == file.name;
      });
      this.uploadList.splice(index, 1);
      this.uploadItems.splice(index, 1);
      console.log("this.uploadLine--;", this.uploadLine);
      //删除该文件后，对应的上传文件线程-1
      this.uploadLine--;
    },
    //切换tab页面
    tabChange(key) {
      console.log(key);
      this.pagination.current = 1;
      this.status = key;
      if (key == 1) {
        let col = {
          title: "发布日期",
          key: "publish_date",
          dataIndex: "publish_date",
          align: "center",
          sorter: (a, b) => {
            return a.upload_time > b.upload_time ? 1 : -1;
          },
        };
        let flag = false;
        this.columns.map((item) => {
          if (item.title == "发布日期") {
            flag = true;
            return;
          }
        });
        if (!flag) {
          this.columns.splice(this.columns.length - 1, 0, col);
        }
      } else {
        this.columns.map((item) => {
          if (item.title == "发布日期") {
            this.columns.splice(this.columns.length - 2, 1);
            return;
          }
        });
      }
      this.getData(key);
    },
  },
  watch: {
    uploadList(Newfile) {
      //当onQueue为true也就是在上传中或者uploadList文件数组上传完为空时，不继续往下执行
      if (this.onQueue === true || Newfile.length == 0) return;
      let files = [...Newfile];
      //判断上传文件线程是否小于设置的上传文件个数限制
      if (this.uploadLine < this.uploadLen) {
        // let newQueueLine = this.uploadLen - this.uploadLine;
        //截取剩余文件放入上传数组
        // let index = this.uploadLine > 0 ? this.uploadLen - 1 : 0;
        // console.log("数组长度",this.uploadLine,newQueueLine)
        // console.log("数组长度22222222",index,newQueueLine)
        // this.uploadItems = files.splice(0,index);
        this.uploadItems = files.slice(0, 1);
        this.uploadLimit(this.uploadItems);
      } else {
        return false;
      }
    },
  },
  mounted() {
    //表格高度自适应
    this.$nextTick(function () {
      this.tableH = document.body.clientHeight - 270; //259
    });
    //窗口改变自适应
    window.onresize = () => {
      return (() => {
        this.tableH = document.body.clientHeight - 270; //259
      })();
    };
  },
};
</script>

<style lang="less" scoped>
#organization {
  // background: #fff;
  overflow: auto;
}
</style>

